import { render, staticRenderFns } from "./InputBlock.vue?vue&type=template&id=3382939e&"
import script from "./InputBlock.vue?vue&type=script&lang=js&"
export * from "./InputBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports